module.exports = __webpack_public_path__ + "static/media/09-Belgravia.fc03317f.mp4";